import axios from "axios";

// Keep track of last search params to preserve pagination after delete
let lastCustomerSearchParams = {
  searchTerm: "",
  page: 0,
  size: 20,
  sortBy: "createdAt",
  sortDirection: "DESC",
  statuses: [],
};

// ===================== Dashboard Data API =====================
export const CustomerManagementData = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "BUILDING_DATA_REQUEST" });
  try {
    const url = `${process.env.REACT_APP_API_URL}/customer`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({ type: "BUILDING_DATA_SUCCESS", payload: response.data });
    }
  } catch (error) {
    dispatch({ type: "BUILDING_DATA_FAILURE", payload: error.message });
  }
};

// ===================== Delete Customer =====================
export const deleteCustomer = (id) => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  const url = `${process.env.REACT_APP_API_URL}/customer/${id}`;

  dispatch({ type: "DELETE_CUSTOMER_REQUEST", payload: id });

  try {
    const response = await axios.delete(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      dispatch({ type: "DELETE_CUSTOMER_SUCCESS" });

      // Refresh customer list, preserving last search params
      try {
        await dispatch(CustomerSearchAction());
      } catch (err) {
        console.error("Failed to refresh customer list:", err);
      }
    } else {
      dispatch({ type: "DELETE_CUSTOMER_FAIL" });
    }
  } catch (error) {
    console.error("Failed to delete customer:", error);
    dispatch({
      type: "DELETE_CUSTOMER_FAIL",
      payload: error?.response?.data?.message || error.message || "Unknown error",
    });
  }
};

// ===================== Add Customer =====================
export const addCustomer = (formData) => async (dispatch) => {
  dispatch({ type: "ADD_CUSTOMER_REQUEST" });
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_API_URL}/customer`;

    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      dispatch({ type: "ADD_CUSTOMER_SUCCESS", payload: response.data });

      // Refresh customer list while preserving current pagination/search
      try {
        await dispatch(CustomerSearchAction());
      } catch (err) {
        console.error("Failed to refresh customer list after add:", err);
      }

    } else {
      dispatch({ type: "ADD_CUSTOMER_FAIL" });
      dispatch(setToastMessage("Failed to add device"));
    }
  } catch (error) {
    console.error("Failed to add device:", error);
    dispatch({
      type: "ADD_CUSTOMER_FAIL",
      payload: error?.response?.data || error.message || "Unknown error",
    });
  }
};


// ===================== Edit Customer =====================
export const editCustomer = (id, formDataToSend) => async (dispatch) => {
  dispatch({ type: "EDIT_CUSTOMER_REQUEST" });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `${process.env.REACT_APP_API_URL}/customer/${id}`;

    const response = await axios.put(url, formDataToSend, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({ type: "EDIT_CUSTOMER_SUCCESS", payload: response.data });

    // Refresh customer list while preserving pagination/search
    try {
      await dispatch(CustomerSearchAction());
    } catch (err) {
      console.error("Failed to refresh customer list after edit:", err);
    }

  } catch (error) {
    console.error("Failed to edit device:", error);
    dispatch({
      type: "EDIT_CUSTOMER_FAILURE",
      payload: error?.response?.data || {},
    });
  }
};


// ===================== Toast Actions =====================
export const setToastMessage = (message) => ({
  type: "SET_TOAST_MESSAGE",
  payload: message,
});

export const setToastOpen = (isOpen) => ({
  type: "SET_TOAST_OPEN",
  payload: isOpen,
});

// ===================== Map Actions =====================
export const fetchOnSelectionData = (data) => ({
  type: "MAP_DATA",
  payload: data,
});

export const markerAction = (data) => ({
  type: "MAP_MARKER_DATA",
  payload: data,
});

export const resestMarkFeild = () => ({
  type: "RESET_MARKER_DATA",
});

// ===================== Customer Data Action =====================
export const customerDataAction = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "CUSTOMER_DATA_REQUEST" });
  try {
    const url = `${process.env.REACT_APP_API_URL}/customer`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      dispatch({ type: "CUSTOMER_DATA_SUCCESS", payload: response.data });
    }
  } catch (error) {
    dispatch({ type: "CUSTOMER_DATA_FAILURE", payload: error.message });
  }
};

// ===================== Customer Search Action =====================
export const CustomerSearchAction = ({
  searchTerm,
  page,
  size,
  sortBy,
  sortDirection,
  statuses,
} = {}) => async (dispatch) => {
  try {
    // Use passed values if given, otherwise use last known values
    const params = {
      searchTerm: searchTerm ?? lastCustomerSearchParams.searchTerm,
      page: page ?? lastCustomerSearchParams.page,
      size: size ?? lastCustomerSearchParams.size,
      sortBy: sortBy ?? lastCustomerSearchParams.sortBy,
      sortDirection: sortDirection ?? lastCustomerSearchParams.sortDirection,
      statuses: statuses ?? lastCustomerSearchParams.statuses,
    };

    // Save the current params for future calls
    lastCustomerSearchParams = { ...params };

    dispatch({ type: "CUSTOMER_SEARCH_REQUEST" });

    const token = JSON.parse(localStorage.getItem("token"));

    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/customer/search`,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({ type: "CUSTOMER_SEARCH_SUCCESS", payload: data });
  } catch (error) {
    dispatch({
      type: "CUSTOMER_SEARCH_FAIL",
      payload: error.response?.data?.message || "Customer search failed",
    });
  }
};
